import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ActionButtonClick, ActionsButtonTable, ColumnsTable, Paginator } from '../../interfaces/basic-table.interface';
import { Table } from 'primeng/table';


@Component({
  selector: 'app-basic-table',
  templateUrl: './basic-table.component.html',
  styleUrl: './basic-table.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BasicTableComponent {
  selectionItem: any[] = [];
  expandedRows: { [key: string]: boolean } = {};

  sortOrder: number = -1;
  previousSortField: string | null = null;

  @Input() columnsTable: ColumnsTable[] = [];
  @Input() dataTable: any[] = [];
  @Input() actionsTable: ActionsButtonTable[] = [];
  @Input() configPaginator: Paginator | null;
  @Input() configButtonToCheck: { title: string, icon?: string } | null = null;
  @Input() configButtonToForm: { title: string, icon?: string } | null = null;
  @Input() tablewithExpasionRow: boolean = false;
  @Input() columnsTableForExpasionRow: ColumnsTable[] = [];
  @Input() nameToPropertySublist: string = '';
  @Input() showCaption: boolean = false;
  @Input() colorearColumna: string[] = [];
  @Output() onClickButtonTable: EventEmitter<ActionButtonClick> = new EventEmitter<ActionButtonClick>();
  @Output() onChangePaginator: EventEmitter<Paginator> = new EventEmitter<Paginator>();
  @Output() onChangeCheckbox: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() onClickButtonToCheck: EventEmitter<void> = new EventEmitter<void>();
  @Output() onClickButtonMassiveForm: EventEmitter<any[]> = new EventEmitter<any[]>();

  /**
    * @author Ministerio de cultura
    * @createdate 2025-02-28
    * Seleccionar las columnas para alineación según su estructura: texto o numérica.
  */
  columnasTexto: string[] = ['Nombre', 'Usuario de ingreso', 'Nombre completo', 'Usuario', 'Entidad', 'Rol', 'Observación', 'Código',
    'Objeto contractual', 'Ob. específico', 'Producto', 'Actividad', 'Dependencia', 'Grupo', 'Proyecto', 'Compromiso', 'Departamento', 'Municipio'];
  columnasNumericas: string[] = ['Presupuesto', 'Recurso', 'Total', 'Total Contrato', 'Valor CDP'];

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-03
    * Metodo para selccionar y colorear las columnas de mayor relevancia. 
  */
  getColumnStyle(columna: string) {
    const index = this.colorearColumna.indexOf(columna);
    const colores = ['#F0C32B1A', '#4B3C8C0D'];
    return index !== -1 ? { 'background-color': colores[index] || '#FFF', 'font-weight': '600' } : {};
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-20
    * Metodo para ordenar las tablas ascendente y descendente 
  */
  setInitialSort(dt: Table, field: string) {
    this.sortOrder = this.previousSortField !== field ? this.sortOrder * -1 : dt.sortOrder * -1;
    this.previousSortField = field;
  }
}

